import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "../../components/ConfirmationModal";
import { UserContext } from "../../v2/common/states/UserState";

const AppropriationAlert = ({
  activeAppropriation,
  appropriations,
  onAppropriate,
  loading,
  entityLabel,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const { user } = useContext(UserContext);

  const handleAppropriateClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirmAppropriate = () => {
    setShowConfirmModal(false);
    onAppropriate();
  };

  const handleCancelAppropriate = () => {
    setShowConfirmModal(false);
  };

  if (!activeAppropriation) {
    const hadPreviousAppropriation = (appropriations || []).length > 0;
    return (
      <>
        <div className="alert alert-warning appropriation-alert" role="alert">
          <span className="appropriation-alert-text">
            <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />
            {hadPreviousAppropriation
              ? `Esta ${entityLabel} não tem apropriação ativa. Clique para se apropriar e continuar a revisão.`
              : `Esta ${entityLabel} ainda não foi apropriada. Clique para se apropriar e iniciar a revisão.`}
          </span>
          <button
            type="button"
            className="btn btn-primary mt-1"
            onClick={handleAppropriateClick}
            disabled={loading}
          >
            {loading ? (
              <FontAwesomeIcon icon="spinner" spin />
            ) : (
              "Apropriar"
            )}
          </button>
        </div>
        <Modal
          visible={showConfirmModal}
          title="Confirmar Apropriação"
          onCancel={handleCancelAppropriate}
          onConfirm={handleConfirmAppropriate}
          cancelText="Cancelar"
          confirmText="Confirmar"
          loading={loading}
        >
          <p>
            Tem certeza que deseja se apropriar desta {entityLabel}? Você poderá
            iniciar a revisão dos documentos após a apropriação.
          </p>
        </Modal>
      </>
    );
  }

  if (activeAppropriation.user.id !== (user && user.id)) {
    return (
      <>
        <div className="alert alert-warning appropriation-alert" role="alert">
          <span className="appropriation-alert-text">
            <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />
            Esta {entityLabel} está apropriada por{" "}
            <strong>{activeAppropriation.user.display_name || activeAppropriation.user.last_name || activeAppropriation.user.username}</strong>.
            Clique para se apropriar.
          </span>
          <button
            type="button"
            className="btn btn-primary ml-3"
            onClick={handleAppropriateClick}
            disabled={loading}
          >
            {loading ? (
              <FontAwesomeIcon icon="spinner" spin />
            ) : (
              "Apropriar"
            )}
          </button>
        </div>
        <Modal
          visible={showConfirmModal}
          title="Confirmar Apropriação"
          onCancel={handleCancelAppropriate}
          onConfirm={handleConfirmAppropriate}
          cancelText="Cancelar"
          confirmText="Confirmar"
          loading={loading}
        >
          <p>
            Esta {entityLabel} está atualmente apropriada por{" "}
            <strong>{activeAppropriation.user.display_name || activeAppropriation.user.last_name || activeAppropriation.user.username}</strong>.
            Tem certeza que deseja se apropriar? A apropriação anterior será
            encerrada automaticamente.
          </p>
        </Modal>
      </>
    );
  }

  return (
    <div className="alert alert-info" role="alert">
      <FontAwesomeIcon icon="info-circle" className="mr-2" />
      Você está apropriado desta {entityLabel} desde{" "}
      <strong>{activeAppropriation.start_date}</strong>.
    </div>
  );
};

AppropriationAlert.propTypes = {
  activeAppropriation: PropTypes.shape({
    id: PropTypes.number,
    user: PropTypes.shape({
      id: PropTypes.number,
      username: PropTypes.string,
      last_name: PropTypes.string,
    }),
    start_date: PropTypes.string,
  }),
  appropriations: PropTypes.arrayOf(PropTypes.object),
  onAppropriate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  entityLabel: PropTypes.string,
};

AppropriationAlert.defaultProps = {
  activeAppropriation: null,
  appropriations: [],
  loading: false,
  entityLabel: "matrícula",
};

export default AppropriationAlert;
